import { takeLatest } from 'redux-saga/effects'
import { CLOSE_AUCTION_CONTRACT_MODAL, CLOSE_BUY_NOW_MODAL } from 'dealer-reducers'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CloseModalFlow(): Generator<any, void, any> {
  try {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    yield (document.body.style.overflow = 'unset')
  } catch (error) {}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CloseModal(): Generator<any, void, any> {
  yield takeLatest([CLOSE_BUY_NOW_MODAL, CLOSE_AUCTION_CONTRACT_MODAL], CloseModalFlow)
}
